// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"771":"9bebbbf3","817":"9bebbbf3"}[chunkId] + ".chunk.css";
};